(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-default"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__productListRotatorInit) return;
  window.__productListRotatorInit = true;

  document.querySelectorAll('.product-list-rotator').forEach(rotator => {
    const items = rotator.querySelectorAll('.product-list-rotator-item');
    if (!items.length) return;

    const computeSize = () => {
      let maxWidth = 0;
      let maxHeight = 0;

      items.forEach((item) => {
        // Absolute positioning means items won't affect layout; we size the container explicitly.
        const width = item.offsetWidth;
        const height = item.offsetHeight;
        if (width > maxWidth) maxWidth = width;
        if (height > maxHeight) maxHeight = height;
      });

      if (maxWidth > 0) rotator.style.width = `${maxWidth}px`;
      if (maxHeight > 0) rotator.style.height = `${maxHeight}px`;
    };

    // Initial sizing (and after fonts load when available).
    computeSize();
    if (document.fonts?.ready) {
      document.fonts.ready.then(computeSize).catch(() => {});
    }
    window.addEventListener('resize', computeSize, { passive: true });

    let index = 0;
    const interval = parseInt(rotator.dataset.interval, 10) || 2000;

    items[index].classList.add('is-active');

    setInterval(() => {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, interval);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-product-tabs]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const cfgEl = root.querySelector('[data-pt-config]');
    let cfg = {};
    try { cfg = JSON.parse(cfgEl?.textContent || '{}'); } catch(e) {}

    const tabs = Array.from(root.querySelectorAll('[data-pt-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-pt-panel]'));
    const accordionHeads = Array.from(root.querySelectorAll('[data-pt-accordion]'));

    if (!panels.length) return;

    const isAvailable = (id) => {
      const key = String(id);
      return !!(cfg?.available && cfg.available[key] === true);
    };

    const setActive = (id, { focusPanel = false } = {}) => {
      const key = String(id);
      if (!isAvailable(key)) return;

      for (const btn of tabs) {
        const on = btn.getAttribute('data-pt-tab') === key;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      }

      for (const acc of accordionHeads) {
        const on = acc.getAttribute('data-pt-accordion') === key;
        acc.setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      for (const p of panels) {
        const on = p.getAttribute('data-pt-panel') === key;
        p.hidden = !on;
        if (on && focusPanel) p.focus({ preventScroll: true });
      }
    };

    const desired = Number(cfg?.defaultTab || 1);
    const initial = isAvailable(desired) ? desired : Number(cfg?.fallbackTab || 1);

    root.addEventListener('click', (e) => {
      const tabBtn = e.target.closest?.('[data-pt-tab]');
      if (tabBtn) { setActive(tabBtn.getAttribute('data-pt-tab')); return; }
      const accBtn = e.target.closest?.('[data-pt-accordion]');
      if (accBtn) {
        const id = accBtn.getAttribute('data-pt-accordion');
        if (accBtn.getAttribute('aria-expanded') === 'true') {
          for (const acc of accordionHeads) acc.setAttribute('aria-expanded', 'false');
          for (const p of panels) p.hidden = true;
          for (const btn of tabs) { btn.setAttribute('aria-selected', 'false'); btn.tabIndex = -1; }
        } else {
          setActive(id);
        }
        return;
      }
    });

    root.addEventListener('keydown', (e) => {
      const currentBtn = e.target.closest?.('[data-pt-tab]');
      if (!currentBtn) return;

      const visibleTabs = tabs.filter((b) => isAvailable(b.getAttribute('data-pt-tab')));
      const idx = visibleTabs.indexOf(currentBtn);
      if (idx < 0) return;

      const go = (nextIdx) => {
        const b = visibleTabs[(nextIdx + visibleTabs.length) % visibleTabs.length];
        b.focus();
        setActive(b.getAttribute('data-pt-tab'));
      };

      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(idx - 1); }
      if (e.key === 'Home')       { e.preventDefault(); go(0); }
      if (e.key === 'End')        { e.preventDefault(); go(visibleTabs.length - 1); }
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setActive(currentBtn.getAttribute('data-pt-tab'), { focusPanel: true });
      }
    });

    setActive(initial);
  });
})();

  // Geo size picker (mobile)
  document.querySelectorAll('[data-pt-geo-mobile]').forEach(function(container) {
    var btns = Array.from(container.querySelectorAll('[data-pt-size]'));
    var vals = Array.from(container.querySelectorAll('[data-pt-size-val]'));
    if (!btns.length) return;

    function selectSize(size) {
      btns.forEach(function(b) {
        b.classList.toggle('is-active', b.getAttribute('data-pt-size') === size);
      });
      vals.forEach(function(v) {
        v.hidden = v.getAttribute('data-pt-size-val') !== size;
      });
    }

    btns.forEach(function(b) {
      b.addEventListener('click', function() { selectSize(b.getAttribute('data-pt-size')); });
    });

    selectSize(btns[0].getAttribute('data-pt-size'));
  });

  (function() {
    function initLightbox() {
      var overlay = document.getElementById('pt-lightbox-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'pt-lightbox-overlay';
        overlay.className = 'pt-lightbox-overlay';
        overlay.innerHTML = '<button class="pt-lightbox-close" aria-label="Fermer">&times;</button><img src="" alt="">';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay || e.target.classList.contains('pt-lightbox-close')) {
            overlay.classList.remove('is-open');
          }
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') overlay.classList.remove('is-open');
        });
      }
      document.querySelectorAll('a.pt-lightbox-trigger').forEach(function(link) {
        if (link.dataset.lightboxInit) return;
        link.dataset.lightboxInit = '1';
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var img = overlay.querySelector('img');
          img.src = link.href;
          img.alt = link.querySelector('img') ? link.querySelector('img').alt : '';
          overlay.classList.add('is-open');
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLightbox);
    } else {
      initLightbox();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
